
import { Component, Inject, HostListener } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { SessionService } from '../../_services/_index';

@Component({
    selector: 'yubi-dialog',
    templateUrl: 'yubi.template.html',
})
export class YubiDialog {

    constructor(
        public dialogRef: MatDialogRef<YubiDialog>,
        private sessionService: SessionService,
        @Inject(MAT_DIALOG_DATA) public data: any) { }

    otp = "";
    trans = "rotate(0deg)"
    porcentaje;
    flag = undefined;

    onNoClick(): void {
        this.dialogRef.close();
    }
    keyEventListening: boolean = true;
    error: string;
    tip: string;
    startTime;

    @HostListener('window:keyup', ['$event'])
    keyEvent(event: KeyboardEvent) {
        if (this.keyEventListening) {
            var now = new Date().getTime()
            if (this.otp.length == 0) {
                this.startTime = new Date().getTime();
            }
            if (this.startTime + 2000 >= now) {
                if (this.otp.length < 44 && event.key.length == 1) {
                    this.otp = this.otp + event.key;
                    this.porcentaje = this.otp.length * 100 / 44;
                    this.trans = "rotate(" + 360 * this.porcentaje / 100 + "deg)";
                }
                if (this.otp.length == 44) {
                    this.keyEventListening = false;
                    this.sessionService.validateOtp(this.otp).subscribe(
                        res => {
                            if (res.Succeed) {
                                this.flag = true;
                                this.error = undefined;
                                setTimeout(
                                    () => {
                                        this.dialogRef.close(true);
                                    }
                                    , 500);
                            }
                            else {
                                this.flag = false;
                                if (res.Message == 'BAD_OTP') {
                                    this.error = 'OTP incorrecto.'
                                    this.tip = 'Por favor no presione ninguna tecla durante este proceso o verifique que el dispositivo sea el correcto'
                                }
                                else {
                                    this.error = res.Message;
                                    this.tip = "";
                                }

                                this.tempDisableKeyListen();
                            }
                        },
                        error => {
                            this.tempDisableKeyListen();
                        },
                        () => {
                            this.otp = "";
                        },
                    );
                }
            }
            else {
                this.flag = false;
                this.otp = "";
                this.error = 'Timeout';
                this.tip = 'Por favor no presione ninguna tecla durante este proceso';
                this.tempDisableKeyListen();
            }
        }
    }

    tempDisableKeyListen() {
        this.keyEventListening = false;
        setTimeout(
            () => {
                this.keyEventListening = true;
                this.flag = undefined;
                this.porcentaje = this.otp.length * 100 / 44;
                this.trans = "rotate(" + 360 * this.porcentaje / 100 + "deg)";
            }
            , 1000);
    }


    getButtonText(button: number) {
        if (button == 1) {
            return this.data.button1 ? this.data.button1 : "Aceptar"
        }
        else {
            return this.data.button2 ? this.data.button2 : "Cancelar"
        }
    }

}